// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Lci-","row":"ProcedureTreatmentSummary_row__2fV2A"};